import { httpFetch } from '@/renderer/utils/http';
import { getApiBase } from '@/renderer/utils/session';
import { getStoredAuthToken } from '@/utils/userApi';
export async function fetchPaymentConfig() {
    const base = getApiBase();
    const tk = getStoredAuthToken();
    const headers = {};
    if (tk)
        headers['Authorization'] = `Bearer ${tk}`;
    const res = await httpFetch(`${base}/api/payments/config`, { method: 'GET', headers, timeoutMs: 10000 });
    if (!res.ok)
        return {};
    try {
        return (await res.json());
    }
    catch {
        return {};
    }
}
